module.exports = __webpack_public_path__ + "static/media/ya.471d4d7c.png";